import React from 'react';
import { AppState } from '../../../../types/store';
import { connect } from 'react-redux';
import { getModuleData } from '../../../selectors/modules';

export interface WithModuleData {
  moduleData?: any;
}

export const withModuleData = <T extends object>(
  Component: React.ComponentType<T>
) => {
  class ComponentWithModuleData extends React.Component<
    Partial<T & WithModuleData>
  > {
    render() {
      return <Component {...this.props as T} />;
    }
  }
  return connect((state: AppState, ownProps) => ({
    moduleData: getModuleData(state, ownProps.moduleId),
  }))(ComponentWithModuleData);
};

export default withModuleData;
